import {inject, injectable} from 'inversify'
import {DI} from '@/src/config/di/types'
import type {IApiClientServiceFactory} from '@/src/ports/services/api'
import {Routes} from '@/src/config/routes'
import {
  CustomLocationSearchResult,
  SearchCustomLocationInterface,
} from '@/src/ports/services/custom-location-search'

@injectable()
export class DadataSearchCustomLocation implements SearchCustomLocationInterface {
  @inject(DI.IApiClientServiceFactory)
  apiClientFactory!: IApiClientServiceFactory

  async search(text: string): Promise<CustomLocationSearchResult[]> {
    const client = this.apiClientFactory('api')

    return await client.get(Routes.api.daDataCustomLocation.search, {params: {text}})
  }
}
